import {
  AddressForm,
  ContactDataIndividual,
  ContactDataOrganization,
  ContactDataType,
  CONTRACT_PARTNER_DATA_KNOWN_KEY,
  INVOICE_ADDRESS_KEY,
  OCCUPIED_CONTRACT_PARTNER_KEY,
  OccupiedContractPartner,
  ORGANIZATION_CONTACT_DATA_KEY,
  POSTAL_ADDRESS_KEY,
  PRIVATE_INDIVIDUAL_CONTACT_DATA_KEY,
} from './model/occupied_contract_partner.model';
import { EMPTY_CONTRACT_PARTNER_KEY, EmptyContractPartner, InvoiceAddressForm } from './model/empty_contract_partner.model';
import { FormGroup } from '@angular/forms';

export function convertOccupiedFormToModel(form: FormGroup<NonNullable<unknown>>): OccupiedContractPartner {
  const formValue = form.get(OCCUPIED_CONTRACT_PARTNER_KEY).value as OccupiedContractPartner;
  const isContractPartnerDataKnown = formValue[CONTRACT_PARTNER_DATA_KNOWN_KEY] !== false;
  if (!isContractPartnerDataKnown) {
    return {
      isContractPartnerDataKnown: false,
      organizationType: null,
      contactDataIndividual: null,
      contactDataOrganization: null,
      invoiceAddress: null,
    };
  }
  const contactDataIndividual = getContactDataIndividual(formValue, form);
  const contactDataOrganization = getContactDataOrganization(formValue, form);
  const invoiceAddress = getPostalAddress(form);
  return {
    isContractPartnerDataKnown: isContractPartnerDataKnown,
    organizationType: formValue.organizationType,
    contactDataIndividual: contactDataOrganization ? null : contactDataIndividual,
    contactDataOrganization: contactDataIndividual ? null : contactDataOrganization,
    invoiceAddress: invoiceAddress,
  };
}

export function convertEmptyFormToModel(form: FormGroup<NonNullable<unknown>>): EmptyContractPartner {
  const formValue = form.get(EMPTY_CONTRACT_PARTNER_KEY).value as EmptyContractPartner;
  const invoiceAddressValue = form.get(INVOICE_ADDRESS_KEY)?.value as InvoiceAddressForm;
  if (!invoiceAddressValue) {
    return {
      company: formValue.company,
      customerNumber: formValue.customerNumber,
      address: formValue.address,
      invoiceAddress: null,
    };
  }
  invoiceAddressValue.company = invoiceAddressValue.company.trim();
  invoiceAddressValue.address.city = invoiceAddressValue.address.city.trim();
  invoiceAddressValue.address.street = invoiceAddressValue.address.street.trim();
  invoiceAddressValue.address.houseNumberStaircase = invoiceAddressValue.address.houseNumberStaircase.trim();
  invoiceAddressValue.address.door = invoiceAddressValue.address.door.trim();
  invoiceAddressValue.address.plz = invoiceAddressValue.address.plz.trim();
  return {
    company: formValue.company,
    customerNumber: formValue.customerNumber,
    address: formValue.address,
    invoiceAddress: invoiceAddressValue,
  };
}

export function getContactDataIndividual(formValue: OccupiedContractPartner, form: FormGroup<NonNullable<unknown>>): ContactDataIndividual {
  if (formValue.organizationType === ContactDataType.PRIVATE_INDIVIDUAL) {
    const contactDataIndividual = form.get(PRIVATE_INDIVIDUAL_CONTACT_DATA_KEY)?.value as ContactDataIndividual;
    if (!contactDataIndividual) {
      return null;
    }
    return {
      ...contactDataIndividual,
      firstName: contactDataIndividual.firstName.trim(),
      lastName: contactDataIndividual.lastName.trim(),
      email: contactDataIndividual.email.trim(),
      phoneNumber: contactDataIndividual.phoneNumber.trim(),
    };
  }
  return null;
}

export function getContactDataOrganization(
  formValue: OccupiedContractPartner,
  form: FormGroup<NonNullable<unknown>>,
): ContactDataOrganization {
  if (formValue.organizationType === ContactDataType.ORGANIZATION) {
    const contactDataOrganization = form.get(ORGANIZATION_CONTACT_DATA_KEY)?.value as ContactDataOrganization;
    if (!contactDataOrganization) {
      return null;
    }
    return {
      ...contactDataOrganization,
      name: contactDataOrganization.name.trim(),
      uid: contactDataOrganization.uid.trim(),
      firmenbuchNr: contactDataOrganization.firmenbuchNr.trim(),
      email: contactDataOrganization.email.trim(),
      phoneNumber: contactDataOrganization.phoneNumber.trim(),
    };
  }
  return null;
}

export function getPostalAddress(form: FormGroup<NonNullable<unknown>>): AddressForm {
  const addressForm = form.get(POSTAL_ADDRESS_KEY)?.value as AddressForm;
  if (!addressForm) {
    return null;
  }
  return {
    ...addressForm,
    plz: addressForm.plz.trim(),
    city: addressForm.city.trim(),
    street: addressForm.street.trim(),
    houseNumberStaircase: addressForm.houseNumberStaircase.trim(),
    door: addressForm.door.trim(),
  };
}
